<template>
  <div class="view-sales-recovery">
    <div class="row justify-content-between py-6">
      <div class="col-lg-4 mb-5 mb-lg-0">
        <span class="table-quantity-counter mr-3">
          Total: {{ initiateCheckout.length }}
        </span>
        <button class="btn p-0 table-refresh" @click="dispatch">
          <i class="fa-solid fa-refresh" />
        </button>
      </div>
      <div class="col-xl-7 col-lg-8">
        <div class="d-flex justify-content-between mb-3">
          <search-filter
            placeholder="E-mail, nome do aluno "
            @search="search"
            class="mb-3 mb-lg-0 flex-fill"
            filterButtonText=""
            showFilters
            :showResultsDropdown="false"
            :newDesign="true"
          >
            <template #custom-filter="{ close }">
              <sale-recovery-filter
                v-model="filters"
                @close="close"
                @input="close"
              />
            </template>
          </search-filter>
          <bp-export-button
            v-if="$permissions.hasPermission('exportar-vendas')"
            size="lg"
            class="ml-3"
            filename="sales_recovery"
            action="sale/exportInitiateCheckout"
            :filters="filters"
            :loading="exportLoading"
            :disabled="!initiateCheckout.length || exportLoading"
          />
        </div>
      </div>
    </div>

    <div class="centralize-row text-center py-7">
      <bp-table-responsive
        ref="BpTableResponsive"
        :pagination-remote-method="onPaginationUpdate"
        paginatorRef="paginator"
        :loading="loading"
        :pagination="pagination"
        :columns="columns"
        :frSize="size"
        :data="initiateCheckout"
      >
        <template #empty>
          <div class="col-lg-12">
            <div class="container centering text-center pt-5">
              <img
                class="d-block mb-5 mx-auto"
                src="@/assets/images/home/welcome.svg"
              />
              <h5>Você ainda não tem compras para recuperar!</h5>
            </div>
          </div>
        </template>
      </bp-table-responsive>
    </div>
  </div>
</template>
<script>
import copy from "copy-text-to-clipboard";
import moment from "moment";
import { mapState } from "vuex";
import SaleRecoveryFilter from "../../components/sale/SaleRecoveryFilter.vue";
import {
  clearObject,
  formatCnpjCpf,
  formatPhone,
  toHumanDate
} from "../../functions/helpers";

export default {
  components: { SaleRecoveryFilter },
  data() {
    return {
      loading: false,
      exportLoading: false,
      product: "",
      filters: {
        product_id: "",
        created_at_after: "",
        created_at_before: "",
        search: ""
      },
      params: {
        limit: 20,
        offset: 0
      }
    };
  },
  computed: {
    ...mapState("sale", ["initiateCheckout", "pagination"]),
    ...mapState("product", ["products"]),
    columns() {
      return [
        {
          name: "Data",
          default: "-",
          field: "created_at",
          transform: toHumanDate
        },
        {
          name: "Comprador",
          default: "-",
          field: "shopper_email",
          transform: (_, item) =>
            `<p class="mb-0 pb-0 text-left">
              <span class="fs-14 fw-4 text-neutral-500">${item.name}</span>
              <br/>
              <span class="fs-12 fw-4 text-neutral-400">${item.email}</span>
            </p>`
        },
        {
          name: "Telefone",
          default: "-",
          field: "phone",
          transform: v => formatPhone(v)
        },
        {
          name: "Documento",
          default: "-",
          field: "document",
          transform: v => formatCnpjCpf(v)
        },
        {
          name: "Link do produto",
          default: "-",
          field: "product",
          transform: (v, item) => {
            return `
              <div class="d-flex align-items-center">
                <button
                  class="btn btn-sm btn-transparent btn-square-sm mr-2"
                  onclick="navigator.clipboard.writeText('${this.getLink(
                    item
                  )}')"
                >
                  <i class="text-primary fa-solid fa-copy"></i>
                </button>
                <a
                  class="btn btn-sm btn-transparent btn-square-sm"
                  href=${this.getLink(item)}
                  target="_blank"
                >
                  <i
                    class="text-primary fa-solid fa-arrow-up-right-from-square"
                  ></i>
                </a>
              </div>
            `;
          }
        }
      ];
    }
  },
  mounted() {
    this.dispatch();
    this.$store.dispatch("product/get", { limit: 1000 });
  },
  filters: {
    formatDate(d) {
      return moment(d).format("DD/MM/YYYY [às] HH:mm:ss");
    }
  },
  methods: {
    search(text) {
      this.filters.search = text;
      this.$refs.paginator.reset();
    },
    async exportCSV() {
      if (this.exportLoading || !this.initiateCheckout.length) return;

      try {
        this.exportLoading = true;
        const CSVContent = await this.$store.dispatch(
          "sale/exportInitiateCheckout",
          clearObject({ ...this.filters, export: true })
        );
        var a = document.createElement("a");

        a.href = `data:text/csv;charset=utf-8,${CSVContent.replaceAll(
          "#",
          "%23"
        )}`;
        a.setAttribute(
          "download",
          `purchase_recovery_${moment().format(
            "YYYYMMDD"
          )}_${moment().unix()}.csv`
        );
        a.click();
      } catch (e) {
      } finally {
        this.exportLoading = false;
      }
    },
    onPaginationUpdate(offset) {
      this.params.offset = offset;
      this.dispatch();
    },
    getLink(item) {
      const queryString = new URLSearchParams(
        clearObject(item.query_params)
      ).toString();
      const product = this.products.find(p => p.id == item.product);
      const URL = `${product.url}?${queryString}`;
      return URL;
    },
    copyLink(item) {
      if (!this.product) {
        this.$message.error(
          "Selecione um produto utilizando o botão filtrar para copiar o link de checkout"
        );
        return;
      }
      const URL = this.getLink(item);
      copy(URL);
      this.$message.success("O link foi copiado!");
    },
    openLink(item) {
      if (!this.product) {
        this.$message.error(
          "Selecione um produto utilizando o botão filtrar para abrir o link de checkout"
        );
        return;
      }

      const URL = this.getLink(item);
      window.open(URL, "_blank");
    },
    dispatch() {
      const params = {
        ...this.filters,
        ...this.params
      };
      this.loading = true;
      this.$store
        .dispatch("sale/getInitiateCheckout", clearObject({ ...params }))
        .finally(() => {
          this.loading = false;
        });
    }
  },
  watch: {
    "filters.product_id"(id) {
      if (id) {
        this.$store
          .dispatch("product/getProduct", id)
          .then(data => (this.product = data));
      } else {
        this.product = "";
      }
    },
    filters() {
      this.params = {
        limit: 20,
        offset: 0
      };
      this.pagination.previous = "";
      this.$refs.paginator.reset();
    }
  }
};
</script>
<style lang="scss" scoped>
.view-sales-recovery {
  small {
    font-size: 100%;
    font-weight: 400;
    color: rgba(59, 59, 74, 0.9);
  }
  strong {
    font-weight: 600;
  }
  ::v-deep .data-table .grid-table {
    align-items: start;
  }
  ::v-deep .font-weight-bold {
    font-weight: 500 !important;
    @media screen and (max-width: 991px) {
      color: rgba(38, 36, 50, 0.93);
    }
  }
}
</style>
